<template>
  <div>
    <div class="home" v-if="ss">
      <Detail />
      <van-empty v-if="price.length == 0" description="暂无数据" />
      <div class="ee" v-else>
        <div
          @click="routers(value)"
          :class="[actives == value.id ? 'active' : '']"
          v-for="value in price"
          :key="value.id"
        >
          <div :class="[value.recommend == 1 ? 'active-b' : 'active-a']">
            <div v-if="value.recommend == 1" class="tuijian">推荐</div>
            <div style="text-align: left">
              <div
                style="font-size: 16px"
                :class="[value.recommend == 1 ? 'clorse' : '']"
              >
                充值金额：
                <span :class="[value.recommend == 1 ? 'clorse' : 'cs']">
                  {{ value.prestoreMoney }}元
                </span>
              </div>
              <div
                style="
                  margin-top: 10px;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <div style="font-size: 14px; margin-right: 15px">
                  赠送金额：
                  <span :class="[value.recommend == 1 ? 'clorse' : 'cs']">
                    {{ value.giveMoney }}元
                  </span>
                </div>
                <div style="font-size: 14px">
                  一共到账：
                  <span :class="[value.recommend == 1 ? 'clorse' : 'cs']">
                    {{ value.giveMoney + value.prestoreMoney }}元
                  </span>
                </div>
              </div>
            </div>
            <div
              v-if="value.description"
              :style="{ color: value.descriptionFontColor, width: '300px' }"
              class="dtext"
            >
              {{ value.description }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-html="this.fom.seriesModel.prestoreTips"
        style="text-align: left"
      ></div>
      <!-- 扫码 -->
      <van-action-sheet
        v-model="showss"
        cancel-text="取消"
        close-on-click-action
      >
        <img style="width: 100%" :src="imagerurl" />
        使用{{ payObj.posType == 1 ? "微信" : "支付宝" }}扫一扫打开
      </van-action-sheet>
      <!-- 商户弹窗 -->
      <van-dialog
        v-model="show"
        :showConfirmButton="false"
        closeOnClickOverlay
        title="支付金额"
      >
        <div style="font-size: 22px; color: red">
          ￥{{ payObj.prestoreMoney }}
        </div>
        <div style="margin-top: 10px; margin-bottom: 20px">
          <van-radio-group v-model="payObj.payRadio">
            <div
              v-for="item in payObj.newPayListItem"
              :key="item.name"
              class="content"
            >
              <div class="display-left">
                <img class="img" :src="item.imgUrl" alt="" />
                {{ item.showName }}
              </div>
              <div class="recommend">
                <div v-if="item.recommend == 1" class="recommends">推荐</div>
              </div>
              <van-radio class="display-right" :name="item.id"></van-radio>
            </div>
          </van-radio-group>
        </div>
        <div style="width: 100%">
          <van-button
            @click="confirm"
            size="small"
            style="width: 80%; margin: 10px 10%; border-radius: 10px"
            type="info"
          >
            确认支付
          </van-button>
        </div>
      </van-dialog>
      <!-- 详情弹窗 -->
      <van-action-sheet
        style="
          background-image: linear-gradient(to left, #198aff, #79bbff);
          color: #ffffff;
        "
        :title="title"
        :close-on-click-overlay="false"
        @cancel="onCancel"
        v-model="shows"
      >
        <Banlance :detail="banlances" @payShow="payShow" />
      </van-action-sheet>
    </div>
  </div>
</template>

<script>
  import { phoneSimCard, prestoreGetAll } from "../api/cardOperation";
  // @ is an alias to /src
  import { xiaoBaiYuanPay } from "@/api/newPay";
  import { Loading } from "element-ui";
  import Detail from "@/components/Detail.vue";
  import Banlance from "@/views/Banlance.vue";
  import { clientGet } from "../api/seting/index";
  // import {phoneSimCard} from "../api/user/index"
  export default {
    name: "Recharge",
    data() {
      return {
        //商户弹窗
        show: false,
        //商户对象
        payObj: {
          payRadio: 0,
          newPayListItem: [],
        },
        //是否传code
        code: "",
        //商户appid
        appId: "",
        //二维码弹窗
        showss: false,
        //二维码地址
        imagerurl: "",
        fom: {},
        ss: false,
        shows: false,
        radio: 1,
        price: [],
        actives: "",
        balance: "",
        giveBalance: 0,
        id: 1,
        nite: {},
        obj: {},
        popss: "",
        banlances: {},
        title: "",
      };
    },
    created() {},
    mounted() {
      if (this.$route.query.code) {
        this.wx(this.$route.query.code, 0, this);
      }

      this.url();
      this.phoneSimCard();
      this.getAll();
      Loading.service();
    },
    methods: {
      // 判断环境
      isWeiXin() {
        undefined;
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          undefined;
          return true;
        } else {
          undefined;
          return false;
        }
      },
      //拉起支付
      xiaoBaiYuanPay(val, val1, val2, val3) {
        xiaoBaiYuanPay(val, val1, val2, val3).then((res) => {
          if (res.status == true) {
            if (res.data.payType == 2) {
              window.location.href = res.data.body;
            } else if (res.data.payType == 3) {
              this.show = false;
              this.imagerurl = `/app/qrcode/qrcode?content=${encodeURIComponent(
                res.data.body
              )}`;
              this.showss = true;
            }
          } else {
            this.$toast(res.msg);
          }
        });
      },
      //确认支付
      confirm() {
        localStorage.removeItem("meall");
        localStorage.setItem("meall", this.payObj.id);
        localStorage.removeItem("meall1");
        localStorage.setItem("meall1", this.payObj.prestoreMoney);
        localStorage.removeItem("meall2");
        localStorage.setItem("meall2", this.payObj.giveMoney);
        this.payObj.newPayListItem.forEach((item) => {
          if (this.payObj.payRadio == item.id) {
            this.code = item.code;
            this.appId = item.appId;
          }
        });

        if (
          this.isWeiXin() == true &&
          this.code == 0 &&
          this.payObj.payType == 1
        ) {
          this.wx(null, 1, this);
        } else {
          if (this.code == 0) {
            this.show = false;
            this.imagerurl =
              window.location.protocol +
              "//" +
              window.location.host +
              `/app/qrcode/qrcode?content=${encodeURIComponent(
                `${window.location.protocol}//${
                  window.location.host
                }/wap/index.html#/wechat?balance=${
                  this.payObj.prestoreMoney
                }&payId=${this.payObj.payRadio}&card=${localStorage.getItem(
                  "meCardNum"
                )}&appId=${this.appId}&balances=${1}`
              )}`;
            this.showss = true;
          } else {
            this.xiaoBaiYuanPay(
              this.payObj.prestoreMoney,
              this.payObj.payRadio,
              "",
              "MWEB"
            );
          }
        }
      },
      //支付商户弹窗
      payShow(val) {
        this.shows = false;
        this.show = true;
        this.payObj = val;
        console.log("支付测试", val);
      },

      weixinSDK(appid, timeStamp, package2, nonceStr, paySign, type) {
        function onBridgeReady() {
          window.WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
              appId: appid,
              timeStamp: timeStamp,
              nonceStr: nonceStr,
              package: package2,
              signType: type,
              paySign: paySign,
            },
            function (res) {
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                // 使用以上方式判断前端返回,微信团队郑重提示：
                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                alert("充值成功");
              } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                alert("取消充值");
              } else if (res.err_msg == "get_brand_wcpay_request:fail") {
                alert("充值失败");
              }
              // if (res.err_msg == "get_brand_wcpay_request:ok") {
              //   // 使用以上方式判断前端返回,微信团队郑重提示：
              //   //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              //   this.$notify({ type: "warning", message: `支付成功` });
              // } else {
              //   this.$toast({
              //     message: "管理员未设置支付",
              //   });
              // }
            }
          );
        }
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              onBridgeReady,
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
            document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
          }
        } else {
          onBridgeReady();
        }
      },
      wx(code, type, than) {
        function jumpLink() {
          //       window.location="https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + that.appId +
          //       "&redirect_uri=" + window.location.protocol + '//' + window.location.host +
          // "&response_type=code&scope=snsapi_userinfo&state=" + time + "#wechat_redirect";''
          const url = encodeURIComponent(
            window.location.protocol +
              "//" +
              window.location.host +
              "/weixinRedirectPay/" +
              localStorage.getItem("meall") +
              "/" +
              localStorage.getItem("meall1") +
              "/" +
              localStorage.getItem("meall2") +
              `?card=${localStorage.getItem("meCardNum")}&payId=${
                than.payObj.payRadio
              }&biaoShi=${than.banlances.a}`
          );
          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            than.appId +
            "&response_type=code&scope=snsapi_userinfo&redirect_uri=" +
            url;
        }
        getUserInfo();
        function getUserInfo() {
          if (code != null && code != undefined && code.trim() != "") {
            xiaoBaiYuanPay(
              localStorage.getItem("meall1"),
              than.$route.query.payId,
              code,
              ""
            ).then((res) => {
              if (res.status) {
                var obj = {};
                obj = res.data.body;
                console.log(obj);
                than.weixinSDK(
                  obj.appId,
                  obj.timeStamp,
                  obj.package,
                  obj.nonceStr,
                  obj.sign,
                  obj.signType
                );
              } else {
                than.$toast(res.msg);
              }
            });
          } else {
            if (type == 1) {
              jumpLink();
            }
          }
        }
      },
      activess() {},
      url() {
        clientGet().then((res) => {
          if (res.status) {
            this.title = "卡号：" + localStorage.getItem("meCardNum");
            this.popss = res.data.payInput;
          }
        });
      },
      onCancel() {
        localStorage.removeItem("obj");
      },
      routers(val) {
        val.a = 0;
        this.banlances = val;
        localStorage.removeItem("obj");
        localStorage.setItem("obj", JSON.stringify(val));
        this.shows = true;
      },
      phoneSimCard() {
        phoneSimCard().then((res) => {
          if (res.status) {
            this.fom = res.data;
            console.log(this.fom);
            Loading.service().close();
            this.ss = true;
          }
        });
      },
      getAll() {
        prestoreGetAll().then((res) => {
          if (res.status) {
            this.price = res.data;
          }
        });
      },
    },
    components: {
      Detail,
      Banlance,
    },
  };
</script>

<style scoped lang="scss">
  .tuijian {
    position: absolute;
    top: 0px;
    right: 0px;
    background-color: #ffca66;
    width: 46px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    border-radius: 0 9px 0 9px;
    font-size: 13px;
    color: white;
  }
  .cs {
    color: #009fff;
    margin-left: -5px;
  }
  .clorse {
    color: #ffa700;
  }
  .dtext {
    text-align: left;
    font-size: 15px;
    margin-top: 10px;
    width: 300px;
  }
  .active-b {
    position: relative;
    width: 100%;
    margin-top: 20px;
    box-sizing: border-box;
    display: flex;
    padding: 15px 10px;
    background: #fef5e4;
    border-radius: 10px;
    border: 1px solid #ffcc6b;
    flex-wrap: wrap;
  }
  .active-a {
    position: relative;
    width: 100%;
    margin-top: 20px;
    box-sizing: border-box;
    border-radius: 10px;
    border: 1px solid #c5e1ff;
    display: flex;
    padding: 15px 10px;
    flex-wrap: wrap;
  }
  .img {
    width: 22px;
    height: 22px;
    vertical-align: middle;
  }
  .content {
    display: flex;
    justify-content: space-between;
    width: 100%;
    background-color: white;
    padding: 10px;
    color: black;
    font-size: 16px;
    box-sizing: border-box;
    border-top: 1px solid rgba(#009fff, 0.2);
    border-bottom: 1px solid rgba(#009fff, 0.2);
  }
  .display-left {
    text-align: left;
    align-items: center;
    justify-self: left;
    width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .display-right {
    display: flex;
    align-items: center;
    width: 45%;
    justify-content: flex-end;
    margin-right: 5%;
  }

  .recommend {
    display: flex;
    align-items: center;
    width: 27px;
  }
  .recommends {
    background: #ffca66;
    color: #ffffff;
    width: 27px;
    text-align: center;
    font-size: 9px;
    height: 15px;
    border-radius: 3px;
  }
  .home {
    padding: 20px;
    box-sizing: border-box;
  }

  .ee {
    width: 100%;
    justify-content: space-around;
    flex-wrap: wrap;
  }
  .ass {
    font-size: 14px;
  }
  .active {
    box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
  }

  .contents {
    width: 100%;
    background-color: white;
    padding: 10px;
    box-sizing: border-box;
  }

  .liuliang {
    margin-top: 20px;
    width: 100%;
    height: 100%;
    background: white;
    border-radius: 20px;
    padding: 10px;
    box-sizing: border-box;
    box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.2);

    .zong {
      font-size: 14px;
      margin-top: 0px;
    }
  }

  .liuliangs {
    width: 100%;
    width: 100%;
    height: 100%;
    margin-top: 20px;
    background: white;
    border-radius: 20px;
    padding: 10px;
    box-sizing: border-box;
    box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.2);

    .zong {
      font-size: 16px;
      margin-top: 0;
    }
  }
</style>
